<template>
  <div class="empty-box">
    <div class="empty-block"></div>
  </div>
</template>
<script setup lang="ts">
defineProps<{ height: string }>()
</script>
<style scoped>
.empty-box {
  height: v-bind(height);
  width: 100%;
  position: relative;
}
.empty-block {
  height: v-bind(height);
  width: 100%;
  position: absolute;
}
</style>
